import { useState } from "react";
import { articles, type Article } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/base/ArticleCard";

export default function LatestNews() {
  const [activeTab, setActiveTab] = useState<string>("all");
  const [visibleCount, setVisibleCount] = useState(8);

  const filteredArticles: Article[] =
    activeTab === "all"
      ? articles
      : articles.filter((a) => a.categorySlug === activeTab);

  const displayedArticles = filteredArticles.slice(0, visibleCount);
  const hasMore = visibleCount < filteredArticles.length;

  return (
    <section className="py-14 md:py-20">
      <div className="container-custom">
        <div className="mb-10">
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-flashlight-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
            <span className="text-primary-500 text-sm font-semibold uppercase tracking-wider">LATEST</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100">
            最新情报
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
          <button
            onClick={() => {
              setActiveTab("all");
              setVisibleCount(8);
            }}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
              activeTab === "all"
                ? "bg-primary-500 text-background-950"
                : "bg-background-100 text-foreground-400 hover:text-foreground-200"
            }`}
          >
            全部
          </button>
          {categories.slice(0, 6).map((cat) => (
            <button
              key={cat.slug}
              onClick={() => {
                setActiveTab(cat.slug);
                setVisibleCount(8);
              }}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1.5 ${
                activeTab === cat.slug
                  ? "bg-primary-500 text-background-950"
                  : "bg-background-100 text-foreground-400 hover:text-foreground-200"
              }`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </div>
              {cat.name}
            </button>
          ))}
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {displayedArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        {displayedArticles.length === 0 && (
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-inbox-line text-4xl text-foreground-600"></i>
            </div>
            <p className="text-foreground-500">该分类下暂无文章</p>
          </div>
        )}

        {/* Load More */}
        {hasMore && (
          <div className="text-center mt-10">
            <button
              onClick={() => setVisibleCount((prev) => prev + 8)}
              className="px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-300 hover:text-foreground-100 rounded-lg text-sm font-medium transition-all duration-200 border border-background-200/60 cursor-pointer"
            >
              加载更多
              <i className="ri-arrow-down-line ml-2 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}